var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 10.175C9.9 10.615 9.515 11 9.075 11H6.05C5.83 11 5.665 10.945 5.5 10.78L3.3 8.47L3.685 8.03C3.795 7.92 3.96 7.865 4.125 7.865H4.235L5.5 8.8V3.85C5.5 3.52 5.72 3.3 6.05 3.3C6.38 3.3 6.6 3.52 6.6 3.85V6.325L7.26 6.38L9.405 7.59C9.68 7.7 9.9 8.03 9.9 8.305V10.175ZM9.9 0H1.1C0.495 0 0 0.495 0 1.1V5.5C0 6.105 0.495 6.6 1.1 6.6H3.3V5.5H1.1V1.1H9.9V5.5H8.8V6.6H9.9C10.505 6.6 11 6.105 11 5.5V1.1C11 0.495 10.505 0 9.9 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.6e3d4198243e4074daa2149065bb252e.svg";
export { ForwardRef as ReactComponent };